import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const rejectDraftReview = api(async function rejectDraftReview({ projectId, scheduleId, rejectionSummary }) {
    if (!projectId || !scheduleId) return false

    return mutate(
        gql`
            mutation RejectDraftReview($projectId: String!, $scheduleId: String!, $rejectionSummary: String) {
                rejectDraftReview(projectId: $projectId, scheduleId: $scheduleId, rejectionSummary: $rejectionSummary)
            }
        `,
        { projectId, scheduleId, rejectionSummary },
        { returns: "rejectDraftReview" }
    )
})
